import React, { useState, useEffect } from "react";
import logo from "../assets/resume/logo.png";
import { NavLink, useNavigate } from "react-router-dom";
import "./Styles.css";
import { IoSearchSharp } from "react-icons/io5";
import Box from "@mui/material/Box";
import { FaAward, FaBirthdayCake, FaCcVisa, FaCertificate, FaUser } from "react-icons/fa";
import {  MdCardGiftcard, MdFavorite, MdKeyboardArrowDown, MdLeaderboard, MdPerson } from "react-icons/md";
import { SiTinyletter } from "react-icons/si";
import Modal from "@mui/material/Modal";
import { auth } from "../FirebaseConfig";
import { signInWithPopup, GoogleAuthProvider, signInWithEmailAndPassword,sendPasswordResetEmail , onAuthStateChanged, sendEmailVerification,createUserWithEmailAndPassword, updateProfile }  from "firebase/auth";
import Goo from "../assets/icons/Picture1.png";
import { useSelector, useDispatch } from "react-redux";
import { loginUser, language, loginModal } from "../Redux/authAction";
import { loginDeveloper } from "../Redux/authAction";
import Avatar from "../components/avatar";
import Input from "../components/input";
import Snackbar from "@mui/material/Snackbar";
import MuiAlert from "@mui/material/Alert";
import login from "../assets/home/gmail.jpg";
import { display } from "@mui/system";
import apiConfig from '../config/api.js';

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "clamp(750px,100%,300px)",
  height: "600px",
  bgcolor: "background.paper",
  border: "0px solid #000",
  boxShadow: 24,
  p: 4,
};

const Header = (props) => {
  const [name, setName] = useState("");
  const [emaill, setEmaill] = useState("");
  const [password, setPassword] = useState("");
 
  const [errorMessage, setErrorMessage] = useState("");
  const navigate = useNavigate();
  const state = props.menu;
  const setState = props.setMenu;
  const dispatch = useDispatch();
  const [openModel, setOpenModel] = useState(false);
  const [logEmail, setLogEmail] = useState("");
  const [logPassword, setLogPassword] = useState("");
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarSeverity, setSnackbarSeverity] = useState("success");

  const [pkgid, setpkgid]= useState('');
  const [pkgstatus, setpkgstatus]= useState('')
  const isAuthenticated = useSelector((state) => state.authReducer.isAuthenticated);
  
  const isLang = useSelector((state) => state.authReducer.lang);
  const loginModalValue = useSelector((state) => state.authReducer.loginModal);

  const handleOpen = () => dispatch(isAuthenticated === false ? loginModal(true) : loginModal(false));
  const handleClose = () => dispatch(loginModal(false));
  const packageidid = useSelector((state) => state.authReducer.packageid); // Moved outside

  
  const handleMouseOver_down = (type) => {
    setState(type);
  };

  const handleSnackbarClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setSnackbarOpen(false);
  };
  const developerrole = useSelector((state) => state.authReducer.developerrole);

  useEffect(() => {
    
    if(developerrole=== "Designer"){
      navigate('/Templates')
    }
    if (isAuthenticated === "false") {
      dispatch(loginModal(false));
    }
  }, [isAuthenticated, dispatch]);
  


  const handlePasswordReset = async (auth, emaill) => {
    console.log("The Email is   :" + emaill);
    try {
      if (!emaill) {
        setSnackbarSeverity("error");
        setSnackbarMessage("Please enter a valid email address.");
        setSnackbarOpen(true);
        return;
      }

      await sendPasswordResetEmail(auth, emaill);
      setSnackbarSeverity("success");
      setSnackbarMessage(`Password reset email sent to ${emaill}. Please check your inbox.`);
      setSnackbarOpen(true);
    } catch (error) {
      let errorMessage = "An error occurred.";
      if (error.code === "auth/user-not-found") {
        errorMessage = "No user found with this email.";
      } else if (error.code === "auth/invalid-email") {
        errorMessage = "Invalid email address.";
      }
      setSnackbarSeverity("error");
      setSnackbarMessage(errorMessage);
      setSnackbarOpen(true);
    }
  };


  const handleSignup = async () => {
    try {
      if (name && emaill && password) {
        // Create user with email and password
        const userCredential = await createUserWithEmailAndPassword(auth, emaill, password);
        const user = userCredential.user;
        
        // Update user profile with display name
        await updateProfile(user, { displayName: name });
        
        // Send email verification
        await sendEmailVerification(user);
  
        setSnackbarSeverity("success");
        setSnackbarMessage("Signup successful! A verification email has been sent.");
        setSnackbarOpen(true);
  
        handleCloseModel();
      } else {
        setSnackbarSeverity("error");
        setSnackbarMessage("Please enter a valid name, email, and password.");
        setSnackbarOpen(true);
      }
    } catch (error) {
      let errorMessage = "Unexpected error occurred.";
      if (error.code === "auth/email-already-in-use") {
        errorMessage = "The email address is already in use.";
      } else if (error.code === "auth/invalid-email") {
        errorMessage = "The email address is not valid.";
      } else if (error.code === "auth/weak-password") {
        errorMessage = "The password is too weak.";
      }
      setSnackbarSeverity("error");
      setSnackbarMessage(errorMessage);
      setSnackbarOpen(true);
    }
  };

  
  const handleDesignerSignup = async () => {
    try {
      if (name && emaill && password ) {

        const loginData = new FormData();
        loginData.append("username", emaill);
        loginData.append("password", password);
        loginData.append("fullname", name);
        loginData.append("role","Designer");

        try {

          const response = await fetch(`${apiConfig.API_URL}/aapi/developer_api/register.php`, {
            method: "POST",
            body: loginData, // Send FormData object instead of JSON
          });
    
          if (!response.ok) {
            throw new Error("Login failed, please try again.");
          }
        } catch(error){
          console.error("Signup :", error.message);
          // Show error snackbar
          setSnackbarSeverity("error");
          setSnackbarMessage("Failed to SignUp. Please check your credentials.");
          setSnackbarOpen(true);
          handleCloseModel();
        }
        try{
          
          const emaildata = new FormData();
          emaildata.append("to",emaill);
          emaildata.append("subject","Account Verification");
          // Generate the verification URL
const verificationUrl = `${apiConfig.API_URL}/aapi/developer_api/developeremailverification.php?email=${encodeURIComponent(emaill)}`;

// Create an HTML email with a button
const emailContent = `
  <html>
    <body>
      <p>Thank you for signing up! Please click the button below to verify your account:</p>
      <a href="${verificationUrl}" style="
        display: inline-block;
        padding: 10px 20px;
        font-size: 16px;
        color: white;
        background-color: #4c76cf;
        text-decoration: none;
        border-radius: 5px;
      ">Verify Email</a>
      <p>If you did not sign up, you can ignore this email.</p>
    </body>
  </html>
`;

// Append the HTML content to your email data
emaildata.append("message", emailContent);

          const response = await fetch(`${apiConfig.API_URL}/aapi/desingersendemail.php`, {
            method: "POST",
            body: emaildata, // Send FormData object instead of JSON
          });

          if (!response.ok) {
            throw new Error("Failed to send email!.");
          }

        }
        catch(error){
          setSnackbarSeverity("error");
          setSnackbarMessage(errorMessage);
          setSnackbarOpen(true);

        }
        setSnackbarSeverity("success");
        setSnackbarMessage("Signup successfull! Verification Email has been sent!");
        setSnackbarOpen(true);
  
        handleCloseModel();
      } else {
        setSnackbarSeverity("error");
        setSnackbarMessage("Please enter a valid name, email, and password.");
        setSnackbarOpen(true);
      }
    } catch (error) {
      let errorMessage = "Unexpected error occurred.";
      if (error.code === "auth/email-already-in-use") {
        errorMessage = "The email address is already in use.";
      } else if (error.code === "auth/invalid-email") {
        errorMessage = "The email address is not valid.";
      } else if (error.code === "auth/weak-password") {
        errorMessage = "The password is too weak.";
      }
      setSnackbarSeverity("error");
      setSnackbarMessage(errorMessage);
      setSnackbarOpen(true);
    }
  };
  
  
  const handleLogin = async () => {
   
    try {
      if (emaill && password) {
        // Sign in with email and password
        const userCredential = await signInWithEmailAndPassword(auth, emaill, password);
        const user = userCredential.user;
        const { displayName, email, uid } = user; // Fix: Renamed email_ back to email
        console.log("The display name is  :" + displayName);
        console.log("The email is  :" + email); // Fix: Correct variable name
        console.log("The UID is  :" + uid);
        
        // Send UID to fetch subscription data
        const formData = new FormData();
        formData.append("uid", uid);
  
        const response = await fetch(`${apiConfig.API_URL}/aapi/getsubscriptiondata.php`, {
          method: "POST",
          body: formData,
        });
  
        if (!response.ok) {
          throw new Error("Failed to fetch subscription data.");
        }
  
        const data = await response.json();
  
        if (data.status === "success" && data.data.length > 0) {
          const subscription = data.data[0]; // Get the first subscription record
          const { packageid, status } = subscription;
  
          // Dispatch login details to Redux
          dispatch(loginUser({ displayName, email, uid, packageid, status })); // Fix: Using 'email' here
  
          console.log("The ID from redux name is  ------------------------ >  :" + packageidid);
          console.log("The UID from redux name is  ------------------------ >  :" + uid);
          // Show success snackbar
          setSnackbarSeverity("success");
          setSnackbarMessage(isLang === "arabic" ? "تسجيل الدخول بنجاح!" : "Login successful!");
          setSnackbarOpen(true);
  
          // Close login modal
          dispatch(loginModal(false));
          handleCloseModel();
        } else {
          // If no subscription found, show an error
          setSnackbarSeverity("error");
          setSnackbarMessage(isLang === "arabic" ? "لم يتم العثور على اشتراك." : "No subscription found.");
  
          const subscription = data.data[0]; // Get the first subscription record
          const { packageid, status } = subscription;
          dispatch(loginUser({ displayName, email, uid, packageid, status })); // Fix: Using 'email' here
  
          console.log("The ID from redux name is  ------------in case of no data------------ >  :" + packageidid);
          setSnackbarOpen(true);
          handleCloseModel();
        }
      } else {
        // If email or password is missing, show an error
        setSnackbarSeverity("error");
        setSnackbarMessage(isLang === "arabic" ? "يرجى إدخال البريد الإلكتروني وكلمة المرور." : "Please enter both email and password.");
        setSnackbarOpen(true);
        handleCloseModel();
      }
    } catch (error) {
      console.error("Login Error:", error.message);
  
      // Show error snackbar
      setSnackbarSeverity("error");
      setSnackbarMessage(isLang === "arabic" ? "فشل تسجيل الدخول. تحقق من بياناتك." : "Failed to login. Please check your credentials.");
      setSnackbarOpen(true);
      handleCloseModel();
    }
  };

  const handleDesignerLogin = async (e) => {
    e.preventDefault();

    // Create a FormData object and append the email and password
    const loginData = new FormData();
    loginData.append("username", emaill);
    loginData.append("password", password);

    try {
      const response = await fetch(`${apiConfig.API_URL}/aapi/developer_api/login.php`, {
        method: "POST",
        body: loginData, // Send FormData object instead of JSON
      });

      const result = await response.json();
      if (result.status === "error") {
        setErrorMessage(result.message );
      }
      else{      
      const data = result.data;
      console.log("----data----",data);
      const developername = data.fullname;
      const developeremail = data.username;
      const developerrole = data.role;
      const developeruid = data.id;
      dispatch(loginDeveloper({developername, developeremail,developerrole , developeruid}));
    }
      // If login is successful, update local state and close modal
      if (result.status === "success") {
        setErrorMessage("Login successful!"); // Display success message
        // alert("User logged is as desinger");
        setTimeout(() => {
          setIsLoggedIn(true); // Set logged in state to true
          setIsModalOpen(false); // Close modal after success message is displayed
          setErrorMessage(""); // Clear the error message
          
        }, 1500); // Delay modal closing by 1.5 seconds
        navigate("/Templates");
      } else {
        setErrorMessage(result.message || "Login failed. Invalid credentials.");
      }
    } catch (error) {
      setErrorMessage(error.message || "An error occurred. Please try again.");
    }
  };
  const [openDesignerLoginModal, setOpenDesignerLoginModal] = useState(false);
const handleOpenDesignerLogin = () => setOpenDesignerLoginModal(true);
const handleCloseDesignerLogin = () => setOpenDesignerLoginModal(false);

const [openDesignerSignupModal, setOpenDesignerSignupModal] = useState(false);
const handleOpenDesignerSignup = () => setOpenDesignerSignupModal(true);
const handleCloseDesignerSignup = () => setOpenDesignerSignupModal(false);
  

  const handelOpenModel = () => {
    dispatch(loginModal(false))
    setOpenModel(true);
  };
  const handleClose2 = () => {
    dispatch(loginModal(false)) 
    dispatch(loginModal(false))
  };



  const handleCloseModel = () => setOpenModel(false);
  

  

  const handleGoogleLogin = () => {
    const provider = new GoogleAuthProvider();
    signInWithPopup(auth, provider)
      .then((result) => {
        const user = result.user;
        const { displayName, email, uid } = user;
        
        dispatch(loginUser({ displayName, email, uid }));
        dispatch(loginModal(false));
        window.location.href = "/category/design/Promotion Maker";
      })
      .catch((error) => {
        console.error("Google Login Error:", error.message);
      });
  };

  return (
    <>
      <div className={`flex items-center shadow-lg z-50 h-20 px-4 py-2 fixed w-full bg-white ${isLang === "arabic" ? "flex-row-reverse" : ""}`}>
        <NavLink to={isAuthenticated ? "/category/design/Promotion Maker" : "/"} className="focus:outline-none absolute">
          <img src={`${logo}`} className="cursor-pointer w-[200px] h-14" alt="Logo" />
        </NavLink>

        <div className={`flex ${isLang === "arabic" ? "flex-row-reverse" : "md:ml-[80px]"} w-full gap-8 justify-center items-center mx-auto`}>
          <NavLink to={isAuthenticated ? "/category/design/Promotion Maker" : "/"} className="flex gap-1 items-center cursor-pointer focus:outline-none hover:no-underline">
            <p className="text-[#656565] font-[500] text-[14px] btns px-3" style={{ fontFamily: "poppins", fontSize: "16px" }}>
              {isLang === "arabic" ? "الصفحة الرئيسية" : "Home"}
            </p>
          </NavLink>

          <NavLink onMouseOver={() => handleMouseOver_down("promo")} to={isAuthenticated ? "/category/design/Promotion Maker" : "/Catelog"} className="flex gap-1 items-center cursor-pointer focus:outline-none hover:no-underline">
            <p className="text-[#656565] font-[500] text-[14px] btns px-3" style={{ fontFamily: "poppins", fontSize: "16px" }}>
              {isLang === "arabic" ? "منشئ الترويج" : "Promotion Maker"}
            </p>
            <MdKeyboardArrowDown className="text-[#3b3838] font-[400]" />
          </NavLink>

          <NavLink onMouseOver={() => handleMouseOver_down("resume")} to={isAuthenticated ? "/category/design/Resume Maker" : "/ResumeMaker"} className="flex gap-1 items-center cursor-pointer focus:outline-none hover:no-underline">
            <p className="text-[#656565] font-[500] text-[14px] btns px-3" style={{ fontFamily: "poppins", fontSize: "16px" }}>
              {isLang === "arabic" ? "منشئ السيرة الذاتية" : "Resume Maker"}
            </p>
            <MdKeyboardArrowDown className="text-[#3b3838] font-[400]" />
          </NavLink>

          <NavLink onMouseOver={() => handleMouseOver_down("design")} to={isAuthenticated ? "/category/design/Logo Maker" : "/LogoMaker"} className="flex gap-1 items-center cursor-pointer focus:outline-none hover:no-underline">
            <p className="text-[#656565] font-[500] text-[14px] btns px-3" style={{ fontFamily: "poppins", fontSize: "16px" }}>
              {isLang === "arabic" ? "منشئ الشعار" : "Logo Maker"}
            </p>
          </NavLink>

          <NavLink to="/price" className="flex gap-1 items-center cursor-pointer hover:no-underline focus:outline-none">
            <p className="text-[#656565] font-[500] text-[14px] text-nowrap px-3  btns" style={{ fontFamily: "poppins", fontSize: "16px" }}>
              {isLang === "arabic" ? "التسعير" : "Pricing"}
            </p>
          </NavLink>
        </div>

        <div className="flex items-center gap-4">
          <Input />
          <div className="cursor-pointer" onClick={() => dispatch(language(isLang === "arabic" ? "eng" : "arabic"))}>
            <p className="font-[600] text-[16px] text-[#656565]">{isLang === "arabic" ? "English" : "العربية"}</p>
          </div>
          {isAuthenticated ? <Avatar /> : (
            <button onClick={handleOpen} className="text-[#656565] focus:outline-none font-[500] text-[14px] text-nowrap hover:underline" style={{ fontFamily: "poppins", fontSize: "16px" }}>
              {isLang === "arabic" ? "تسجيل الدخول" : "Sign In"}
            </button>
          )}
        </div>
      </div>

      //-------------dropdown start-------------------
      <div className={`transition-all duration-700 z-50 fixed ${isLang === "arabic" ? "flex-row-reverse" : ""}`}>
  {state === "promo" && (
    <div
      className={`absolute top-[50px] w-[500px] ${isLang === "arabic" ? " left-[30vw] " : " left-[16vw] "} bg-white shadow-xl rounded-xl`}
      onMouseLeave={() => handleMouseOver_down("")}
      style={{ zIndex: 999 }}
    >
      <div className="m-auto">
        <div className={`flex gap-12 px-7 ${isLang === "arabic" ? "flex-row-reverse" : ""}`}>
          <div className={`flex flex-col gap-3 py-5 ${isLang === "arabic" ? "text-right" : ""}`}>
            <NavLink
              to={isAuthenticated === false ? "/Catelog" : "/category/design/Promotion Maker"}
              className={`flex ${isLang === "arabic" ? "flex-row-reverse" : "flex-row"} gap-3 items-center cursor-pointer hover:no-underline focus:outline-none`}
            >
              <div className={`flex ${isLang === "arabic" ? "flex-row-reverse" : "flex-row"} gap-4 items-center transition-all duration-500 hover:bg-slate-100 p-2 rounded-sm`}>
                <div className="text-3xl bg-yellow-200 text-white p-2 rounded-md" style={{ backgroundColor: '#A450F3' }}>
                  <MdLeaderboard />
                </div>
                <div>
                  <p className="text-[16px] font-[600]" style={{ fontFamily: "poppins" }}>
                    {isLang === "arabic" ? "منشئ الترويج" : "Promotion Maker"}
                  </p>
                  <p className="text-[14px] font-[400]" style={{ fontFamily: "poppins", color: "#414751" }}>
                    {isLang === "arabic" ? "إنشاء ومشاركة المواد الترويجية." : "Create and share promotional materials."}
                  </p>
                </div>
              </div>
            </NavLink>

            <NavLink
              to={isAuthenticated === false ? "/Weddingcards" : "/category/design/Wedding Cards"}
              className={`flex ${isLang === "arabic" ? "flex-row-reverse" : "flex-row"} gap-3 items-center cursor-pointer hover:no-underline focus:outline-none`}
            >
             <div className={`flex ${isLang === "arabic" ? "flex-row-reverse" : "flex-row"} gap-4 items-center transition-all duration-500 hover:bg-slate-100 p-2 rounded-sm`}>
                <div className="text-3xl bg-yellow-200 text-white p-2 rounded-md" style={{ backgroundColor: '#A450F3' }}>
                  <MdFavorite />
                </div>
                <div>
                  <p className="text-[16px] font-[600]" style={{ fontFamily: "poppins" }}>
                    {isLang === "arabic" ? "بطاقات الزفاف" : "Wedding Cards"}
                  </p>
                  <p className="text-[14px] font-[400]" style={{ fontFamily: "poppins", color: "#414751" }}>
                    {isLang === "arabic" ? "تصميم دعوات الزفاف." : "Design beautiful wedding invitations."}
                  </p>
                </div>
              </div>
            </NavLink>

            <NavLink
              to={isAuthenticated === false ? "/BirthdayCards" : "/category/design/Birthday Cards"}
              className={`flex ${isLang === "arabic" ? "flex-row-reverse" : "flex-row"} gap-3 items-center cursor-pointer hover:no-underline focus:outline-none`}
            >
             <div className={`flex ${isLang === "arabic" ? "flex-row-reverse" : "flex-row"} gap-4 items-center transition-all duration-500 hover:bg-slate-100 p-2 rounded-sm`}>
                <div className="text-3xl bg-yellow-200 text-white p-2 rounded-md" style={{ backgroundColor: '#A450F3' }}>
                  <MdCardGiftcard />
                </div>
                <div>
                  <p className="text-[16px] font-[600]" style={{ fontFamily: "poppins" }}>
                    {isLang === "arabic" ? "بطاقات عيد الميلاد" : "Birthday Cards"}
                  </p>
                  <p className="text-[14px] font-[400]" style={{ fontFamily: "poppins", color: "#414751" }}>
                    {isLang === "arabic" ? "إنشاء بطاقات عيد الميلاد الشخصية." : "Create personalized birthday cards."}
                  </p>
                </div>
              </div>
            </NavLink>
          </div>
        </div>
      </div>
    </div>
  )}

  {state === "resume" && (
    <div
      className={`absolute top-[50px] w-[500px] ${isLang === "arabic" ? " left-[30vw] " : " left-[16vw] "} bg-white shadow-xl rounded-xl`}
      onMouseLeave={() => handleMouseOver_down("")}
      style={{ zIndex: 999 }}
    >
      <div className="m-auto w-full">
        <div className={`flex gap-12 px-7 w-full ${isLang === "arabic" ? "flex-row-reverse" : ""}`}>
          <div className={`flex flex-col gap-3 py-5 w-full ${isLang === "arabic" ? "text-right" : ""}`}>
            <NavLink
              to="/ResumeMaker"
              className={`flex ${isLang === "arabic" ? "flex-row-reverse" : "flex-row"} gap-3 items-center cursor-pointer hover:no-underline focus:outline-none`}
            >
             <div className={`flex ${isLang === "arabic" ? "flex-row-reverse" : "flex-row"} gap-4 items-center transition-all duration-500 hover:bg-slate-100 p-2 rounded-sm`}>
                <div className="text-3xl bg-yellow-200 text-white p-2 rounded-md" style={{ backgroundColor: '#A450F3' }}>
                  <MdPerson />
                </div>
                <div>
                  <p className="text-[16px] font-[600]" style={{ fontFamily: "poppins" }}>
                    {isLang === "arabic" ? "منشئ السيرة الذاتية" : "Resume Maker"}
                  </p>
                  <p className="text-[14px] font-[400]" style={{ fontFamily: "poppins", color: "#414751" }}>
                    {isLang === "arabic" ? "بناء سيرتك الذاتية المهنية." : "Build your professional resume."}
                  </p>
                </div>
              </div>
            </NavLink>

            <NavLink
              to="/EmployeeCertificate"
              className={`flex ${isLang === "arabic" ? "flex-row-reverse" : "flex-row"} gap-3 items-center cursor-pointer hover:no-underline focus:outline-none`}
            >
              <div className={`flex ${isLang === "arabic" ? "flex-row-reverse" : "flex-row"} gap-4 items-center transition-all duration-500 hover:bg-slate-100 p-2 rounded-sm`}>
                <div className="text-3xl bg-yellow-200 text-white p-2 rounded-md" style={{ backgroundColor: '#A450F3' }}>
                  <FaAward />
                </div>
                <div>
                  <p className="text-[16px] font-[600]" style={{ fontFamily: "poppins" }}>
                    {isLang === "arabic" ? "شهادات الموظف" : "Employee Certificates"}
                  </p>
                  <p className="text-[14px] font-[400]" style={{ fontFamily: "poppins", color: "#414751" }}>
                    {isLang === "arabic" ? "إنشاء شهادات الموظف." : "Generate employee certificates."}
                  </p>
                </div>
              </div>
            </NavLink>

            <NavLink
              to="/CoverLetter"
              className={`flex ${isLang === "arabic" ? "flex-row-reverse" : "flex-row"} gap-3 items-center cursor-pointer hover:no-underline focus:outline-none`}
            >
             <div className={`flex ${isLang === "arabic" ? "flex-row-reverse" : "flex-row"} gap-4 items-center transition-all duration-500 hover:bg-slate-100 p-2 rounded-sm`}>
                <div className="text-3xl bg-yellow-200 text-white p-2 rounded-md" style={{ backgroundColor: '#A450F3' }}>
                  <SiTinyletter />
                </div>
                <div>
                  <p className="text-[16px] font-[600]" style={{ fontFamily: "poppins" }}>
                    {isLang === "arabic" ? "خطاب التغطية" : "Cover Letter"}
                  </p>
                  <p className="text-[14px] font-[400]" style={{ fontFamily: "poppins", color: "#414751" }}>
                    {isLang === "arabic" ? "اكتب خطاب تغطية مقنع." : "Write a compelling cover letter."}
                  </p>
                </div>
              </div>
            </NavLink>
          </div>
        </div>
      </div>
    </div>
  )}
</div>

      //-------------dropdown ends-------------------

      <Modal
  open={loginModalValue}
  onClose={handleClose}
  aria-labelledby="modal-modal-title"
  aria-describedby="modal-modal-description"
>
  <Box sx={style} className="rounded-lg text-[#262b33]">
    <div className="flex">
      <div className="w-[50%] h-[70vh] flex flex-col gap-4 mr-7 ml-2">
        <p className="mb-[30px] mt-[20px] text-[28px] font-[700] relative -left-3">Welcome back!!</p>
        <div>
          <p>Email:</p>
          <input
            type="text"
            placeholder="Email"
            value={emaill}
            onChange={(e) => setEmaill(e.target.value)}
            className="p-2 border-2 rounded focus:outline-blue-500 w-full bg-slate-50"
          />
        </div>
        <div>
          <p>Password</p>
          <input
            type="password"
            placeholder="Password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            className="p-2 border-2 rounded focus:outline-blue-500 w-full bg-slate-50"
          />
        </div>
        <div onClick={() => handlePasswordReset(auth, emaill)} className="w-full flex justify-end items-center">
          <span>Forget Password?</span>
        </div>
        <button
          onClick={handleLogin}
          className="bg-gradient-to-r from-[#4c76cf] to-[#552ab8] px-7 py-3 rounded-md text-white text-[16px] font-[600] cursor-pointer"
        >
          Login
        </button>
        <button
          onClick={handleGoogleLogin}
          className="flex items-center bg-white dark:bg-gray-900 border border-gray-300 rounded-lg shadow-md px-6 py-2 text-sm font-medium text-gray-800 dark:text-white hover:bg-gray-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-500"
        >
          <img src={Goo} className="h-8" alt="Google Logo" />
          <span>Continue with Google</span>
        </button>
        <div style={{ display: "flex", gap: "4px" }}>
          <p>Do Not Have an Account: </p>{" "}
          <button onClick={handelOpenModel} className="focus:outline-none active:outline-none text-[#3b603d] font-[600] hover:underline">
            Sign Up
          </button>
        </div>

        <div style={{display:"flex", gap:"4px"}}>
          Are you a 
        <button 
        onClick={() => {
          handleClose(); // Close Signup Modal
          handleOpenDesignerLogin(); // Open Login Modal
        }}
        className="focus:outline-none active:outline-none text-[#3b603d] font-[600] hover:underline">
  Designer?
</button>

        </div>
      </div>
      <div className="w-[50%] h-[100%] bg-slate-600 overflow-hidden">
        <img src={`${login}`} className="h-full" alt="" />
      </div>
    </div>
  </Box>
</Modal>

<Modal
  open={openDesignerSignupModal}
  onClose={handleCloseDesignerSignup}
  aria-labelledby="designer-signup-modal-title"
  aria-describedby="designer-signup-modal-description"
>
  <Box sx={style} className="rounded-lg text-[#262b33]">
    <div className="flex">
      {/* Image on the left */}
      <div className="w-[50%] h-[100%] bg-slate-600 overflow-hidden">
        <img src={`/herosection/desingerloginmodal.png`} className="h-full" alt="" />
      </div>
      <div className="w-[50%] h-[70vh] flex flex-col gap-4 mr-7 ml-2 pl-4">
        <p className="mb-[30px] mt-[20px] text-[28px] font-[700] relative ">Designer Signup</p>
        <div>
          <label>Name:</label>
          <input
            type="text"
            placeholder="Name"
            value={name}
            onChange={(e) => setName(e.target.value)}
            className="w-full h-9 bg-white focus:outline-none pl-2"
            style={{
              boxShadow: "rgba(0, 0, 0, 0.1) 0px 4px 12px",
              borderRadius: "5px",
              border: "1px solid #63626240",
            }}
          />
        </div>
        <div>
          <label>Email:</label>
          <input
            type="text"
            placeholder="Email"
            value={emaill}
            onChange={(e) => setEmaill(e.target.value)}
            className="w-full h-9 bg-white focus:outline-none pl-2"
            style={{
              boxShadow: "rgba(0, 0, 0, 0.1) 0px 4px 12px",
              borderRadius: "5px",
              border: "1px solid #63626240",
            }}
          />
        </div>
        <div>
          <label>Password:</label>
          <input
            type="password"
            placeholder="Password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            className="w-full h-9 bg-white focus:outline-none pl-2"
            style={{
              boxShadow: "rgba(0, 0, 0, 0.1) 0px 4px 12px",
              borderRadius: "5px",
              border: "1px solid #63626240",
            }}
          />
        </div>
        <button onClick={handleDesignerSignup} className="bg-gradient-to-r from-[#4c76cf] to-[#552ab8] py-2 rounded-md text-white text-[16px] font-[600] cursor-pointer">
          Signup
        </button>
        <button
          onClick={handleGoogleLogin}
          className="flex items-center bg-white dark:bg-gray-900 border border-gray-300 rounded-lg shadow-md px-4 py-[6px] text-sm font-medium text-gray-800 dark:text-white hover:bg-gray-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-500"
        >
          <img src={Goo} className="h-8" alt="Google Logo" />
          <span>Continue with Google</span>
        </button>

        <div className="flex gap-1">
          <p>Already Have an Account?</p>
          <button
            onClick={() => {
              handleCloseDesignerSignup(); // Close Signup Modal
              handleOpenDesignerLogin(); // Open Login Modal
            }}
            className="focus:outline-none active:outline-none text-[#3b603d] font-[600] hover:underline"
          >
            Sign In
          </button>
        </div>
      </div>
    </div>
  </Box>
</Modal>

<Modal
  open={openDesignerLoginModal}
  onClose={handleCloseDesignerLogin}
  aria-labelledby="designer-login-modal-title"
  aria-describedby="designer-login-modal-description"
>
  <Box sx={style} className="rounded-lg text-[#262b33]">
    <div className="flex">
      {/* Image on the left */}
      <div className="w-[50%] h-[100%] bg-slate-600 overflow-hidden">
        <img src="/herosection/desingerloginmodal.png" className="h-full" alt="" />
      </div>
      <div className="w-[50%] h-[70vh] flex flex-col gap-4 mr-7 ml-2 pl-4">
        <p className="mb-[30px] mt-[20px] text-[28px] font-[700] relative ">Designer Login</p>


        {errorMessage && <p className="text-red-500 mb-4">{errorMessage}</p>}

        <div>
          <p>Email:</p>
          <input
            type="text"
            placeholder="Email"
            value={emaill}
            onChange={(e) => setEmaill(e.target.value)}
            className="p-2 border-2 rounded focus:outline-blue-500 w-full bg-slate-50"
          />
        </div>
        <div>
          <p>Password:</p>
          <input
            type="password"
            placeholder="Password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            className="p-2 border-2 rounded focus:outline-blue-500 w-full bg-slate-50"
          />
        </div>
        <button
          onClick={handleDesignerLogin}
          className="bg-gradient-to-r from-[#4c76cf] to-[#552ab8] px-7 py-3 rounded-md text-white text-[16px] font-[600] cursor-pointer"
        >
          Login
        </button>
        {/* <button
          onClick={handleGoogleLogin}
          className="flex items-center bg-white dark:bg-gray-900 border border-gray-300 rounded-lg shadow-md px-6 py-2 text-sm font-medium text-gray-800 dark:text-white hover:bg-gray-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-500"
        >
          <img src={Goo} className="h-8" alt="Google Logo" />
          <span>Continue with Google</span>
        </button> */}
        <div className="flex gap-1">
          <p>Do Not Have an Account?</p>
          <button onClick={() => {
            handleOpenDesignerSignup();
            handleCloseDesignerLogin();
            handleClose(); 
          }}
          className="focus:outline-none active:outline-none text-[#3b603d] font-[600] hover:underline">
            Sign Up
          </button>
        </div>

        {/* Add the "User?" button here */}
        <div className="flex gap-1">
          <p>Are you a </p>
          <button
            onClick={() => {
              handleCloseDesignerLogin();
              handleOpen(); // Opens User Login Modal
            }}
            className="focus:outline-none active:outline-none text-[#3b603d] font-[600] hover:underline"
          >
            User?
          </button>
        </div>
      </div>
    </div>
  </Box>
</Modal>




<Modal
  open={openModel}
  onClose={handleCloseModel}
  aria-labelledby="modal-modal-title"
  aria-describedby="modal-modal-description"
>
  <Box sx={style} className="rounded-lg text-black">
    <div className="flex">
      <div className="w-[50%] h-[70vh] flex flex-col gap-4 mr-7 ml-2">
        <p className="mb-[30px] mt-[20px] text-[28px] font-[700] relative -left-3">Maker4U!</p>
        <div>
          <label>Name:</label>
          <input
            type="text"
            placeholder="Name"
            value={name}
            onChange={(e) => setName(e.target.value)}
            className="w-full h-9 bg-white focus:outline-none pl-2"
            style={{
              boxShadow: "rgba(0, 0, 0, 0.1) 0px 4px 12px",
              borderRadius: "5px",
              border: "1px solid #63626240",
            }}
          />
        </div>
        <div>
          <label>Email:</label>
          <input
            type="text"
            placeholder="Email"
            value={emaill}
            onChange={(e) => setEmaill(e.target.value)}
            className="w-full h-9 bg-white focus:outline-none pl-2"
            style={{
              boxShadow: "rgba(0, 0, 0, 0.1) 0px 4px 12px",
              borderRadius: "5px",
              border: "1px solid #63626240",
            }}
          />
        </div>
        <div className="">
          <label>Password</label>
          <input
            type="password"
            placeholder="Password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            className="w-full h-9 bg-white focus:outline-none pl-2"
            style={{
              boxShadow: "rgba(0, 0, 0, 0.1) 0px 4px 12px",
              borderRadius: "5px",
              border: "1px solid #63626240",
            }}
          />
        </div>
        <button onClick={handleSignup} className="bg-gradient-to-r from-[#4c76cf] to-[#552ab8] py-2 rounded-md text-white text-[16px] font-[600] cursor-pointer">
          Signup
        </button>
        <button
          onClick={handleGoogleLogin}
          className="flex items-center bg-white dark:bg-gray-900 border border-gray-300 rounded-lg shadow-md px-4 py-[6px] text-sm font-medium text-gray-800 dark:text-white hover:bg-gray-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-500"
        >
          <img src={Goo} className="h-8" alt="Google Logo" />
          <span>Continue with Google</span>
        </button>

        <div className="flex gap-1">
          <p>Already Have an Account:</p>
          <button onClick={handleOpen} className="focus:outline-none active:outline-none text-[#3b603d] font-[600] hover:underline">
            Sign In
          </button>
        </div>
      </div>
      <div className="w-[50%] h-[100%] bg-slate-600 overflow-hidden">
        <img src={`${login}`} className="h-full" alt="" />
      </div>
    </div>
  </Box>
</Modal>



      <Snackbar open={snackbarOpen} autoHideDuration={6000} onClose={handleSnackbarClose}>
        <MuiAlert elevation={6} variant="filled" onClose={handleSnackbarClose} severity={snackbarSeverity}>
          {snackbarMessage}
        </MuiAlert>
      </Snackbar>
    </>
  );
};

export default Header;
